import _ from 'lodash';
import * as moment from 'moment-timezone';

import {
  getEventIds,
  getEventOthersFilter,
  getPeriodsState,
  getUniqueChar,
} from '../reducers/analyticsApp';
import { toFilter } from '../converters/filterConverter';
import * as api from '../api/authentication';
import convertLoginResponse from '../converters/loginConverter';
import { requestDelay } from '../constants/common';
import logout from './logout';
import { setErrorMessage } from './application';

const emptyErrorHandler = () => ({});

const dispatchError = (dispatch, error) => {
  dispatch(setErrorMessage(error.text || error.message || 'Something went wrong'));
};

export const buildQueries = (state, detailsAssembler, unitId) => {
  return detailsAssembler(state, unitId);
};

export const getPeriodUniqueChar = (id, periods) =>
  periods
    .map((period, index) => ({
      period,
      uniqueChar: `${index + 1}`,
    }))
    .filter(({ period }) => !!period.from.length)
    .map(({ uniqueChar }) => uniqueChar);

export const createCharArray = (state) => {
  const ids = getEventIds(state);
  const getSplitWithOthersChar = (id) =>
    !getEventOthersFilter(state, id) ? [] : `${getUniqueChar(state, id)}.Others`;

  return ids.flatMap((id) =>
    [getUniqueChar(state, id)]
      .concat(
        getPeriodUniqueChar(id, getPeriodsState(state, id).periods).map(
          (c) => `${getUniqueChar(state, id)}${c}`
        )
      )
      .concat(getSplitWithOthersChar(id))
  );
};

export const transformStep = (step, stepIndex) => ({
  enabled: step.enabled,
  eventName: step.event,
  count: step.count,
  countOperator: step.countOperator,
  closingRange: moment.duration((step.closingRange || {}).value).toISOString(),
  filter: toFilter(step.filter),
  optional: !!step.optional && stepIndex !== 0,
  type: step.type === 'LOCAL_NEGATIVE' ? 'NOT_DONE' : 'DONE',
});

export const asyncAction =
  (type, apiFn, errorHandler = emptyErrorHandler) =>
  (dispatch, getState) => {
    dispatch({
      type: `${type}`,
    });
    return apiFn(dispatch, getState).then(
      (response) => {
        dispatch({
          type: `${type}_SUCCESS`,
          ...response,
        });

        return response;
      },
      (error) => {
        errorHandler(dispatch, getState, error.text || error.message || 'Something went wrong');
        dispatch({
          type: `${type}_FAILURE`,
        });

        dispatchError(dispatch, error);
      }
    );
  };

const jwtDecode = (token) => JSON.parse(atob(token.split('.')[1]));

export const isValidTokens = (authObject) => {
  if (!!authObject.refreshToken.length && !!authObject.accessToken.length) {
    const { iat, exp } = jwtDecode(authObject.accessToken);
    // (время когда токен получен на клиенте)- (время когда токен создан на сервере)
    const difference = authObject.clientTokenTime - iat * 1000;
    // requestDelay - добавляем задержку для исключения случая, когда при проверке токен был валидный,
    // а во время запроса уже стал невалидным
    return exp * 1000 > new Date().valueOf() - difference + requestDelay;
  }
  return false;
};

const getTokenQuery = (tokenOptions) => ({
  refresh_token: tokenOptions.refreshToken,
  grant_type: 'refresh_token',
});

export const updateToken = async (tokenOptions, backendUrl, dispatch) => {
  if (!!tokenOptions.accessToken.length && !!tokenOptions.refreshToken.length) {
    try {
      const response = await api.updateToken({ backendUrl }, getTokenQuery(tokenOptions));
      const updatedToken = convertLoginResponse(response);
      dispatch({
        type: 'UPDATE_TOKEN_SUCCESS',
        ...updatedToken,
        clientTokenTime: new Date().valueOf(),
      });
      return updatedToken;
    } catch (error) {
      dispatchError(dispatch, error);
      dispatch(logout());
    }
  }

  return {};
};

export const throttledUpdateToken = _.throttle(updateToken, 10000, { trailing: false });
